import io from "socket.io-client";
import Manager from "socket.io-client/lib/manager";

/** @type {Manager} */
let Socket;
const END_URL = process.env.REACT_APP_SOCKET_URL;

const connectSocket = () => {
	const stored = localStorage.getItem("profileInfo");
	const userId = stored ? JSON.parse(stored)?.id : null;

	if (!userId) {
		// Guard: never open a socket without a userId — the server will reject it with 401.
		console.warn("[Socket] connectSocket skipped — no userId in localStorage");
		return;
	}

	Socket = io(END_URL, {
		transports: ["websocket"],
		query: { id: userId },
		autoConnect: false,
		reconnection: true,
		reconnectionAttempts: 5,
		allowEIO3: true,
		pingInterval: 30000,
		pingTimeout: 30000,
	});
};

export { connectSocket, Socket };
